'use client';
import { Search, Bot, Handshake, Wallet, User, DollarSign, Sparkles } from 'lucide-react';
import styles from './Ecosystem.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

export function Ecosystem() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        
        <ScrollAnimator>
          <div className={styles.header}>
            <span className={styles.badge}>
              A Jornada do Lucro
            </span>
            <h2>A magia da automação nativa.</h2>
            <p>Veja na prática o que acontece quando a sua empresa roda 100% integrada. Do primeiro contato do lead até o dinheiro cair na sua conta, sem intervenção humana.</p>
          </div>
        </ScrollAnimator>

        <ScrollAnimator delay={200}>
          <div className={styles.flowStage}>
            
            <div className={styles.nodesContainer}>
              
              {/* AS LINHAS DO FUNDO E DO PROGRESSO */}
              <div className={styles.trackLine}>
                <div className={styles.progressLine}></div>
              </div>

              {/* O CLIENTE VIAJANTE (O Avatar que anda pela linha) */}
              <div className={styles.traveler}>
                <User size={22} className={styles.travelerIcon} strokeWidth={2.5} />
              </div>

              {/* NÓ 1: BUSCA LEADS */}
              <div className={`${styles.nodeCard} ${styles.node1}`}>
                <div className={styles.iconWrapper}>
                  <Search size={32} strokeWidth={2.5} />
                </div>
                <h4>1. Captura</h4>
                <p>O Extrator Maps encontra leads B2B qualificados ou suas Campanhas rodam no automático.</p>
              </div>

              {/* NÓ 2: AESIR CHAT + IA */}
              <div className={`${styles.nodeCard} ${styles.node2}`}>
                <div className={styles.iconWrapper}>
                  <Bot size={32} strokeWidth={2.5} />
                </div>
                <h4>2. Atendimento</h4>
                <p>O Aesir Chat recebe o contato, enquanto a IA qualifica o lead e quebra objeções em segundos.</p>
              </div>

              {/* NÓ 3: AESIR CRM */}
              <div className={`${styles.nodeCard} ${styles.node3}`}>
                <div className={styles.iconWrapper}>
                  <Handshake size={32} strokeWidth={2.5} />
                </div>
                <h4>3. Negociação</h4>
                <p>O vendedor assume e acompanha tudo pelo Kanban do CRM, fechando a venda na mesma tela.</p>
              </div>

              {/* NÓ 4: FINANCEIRO & VENDAS */}
              <div className={`${styles.nodeCard} ${styles.node4}`}>
                
                {/* EXPLOSÃO DE LUCRO PREMIUM (Ícones ao invés de Emojis) */}
                <div className={styles.moneyBurst}>
                  <div className={`${styles.burstItem} ${styles.burst1}`}>
                    <Sparkles size={24} />
                  </div>
                  <div className={`${styles.burstItem} ${styles.burst2}`}>
                    <DollarSign size={28} strokeWidth={3} />
                  </div>
                  <div className={`${styles.burstItem} ${styles.burst3}`}>
                    <Sparkles size={20} />
                  </div>
                </div>

                <div className={styles.iconWrapper}>
                  <Wallet size={32} strokeWidth={2.5} />
                </div>
                <h4>4. Faturamento</h4>
                <p>O PDV gera o pedido, o estoque é baixado instantaneamente e o Financeiro emite a NFe.</p>
              </div>

            </div>

          </div>
        </ScrollAnimator>

      </div>
    </section>
  );
}